import { COMPANY_TYPE, type USER_TYPE } from '~/__gql__/graphql';
import { DEPARTMENT_TYPE } from '~/__gql__/graphql';
import { nullString } from '~/shared/constants';
import type { TypeSafeTFunction } from '~/shared/hooks/useTranslation';
import { translateDepartmentType } from '~/shared/utils/dynamicTranslationMaps';

export const isStandardCosunoAdminUser = (user: { email: string }) =>
  user.email === 'administration@cosuno.de';

export const isAgentWithAccessToCompanyProfile = (user?: {
  company: { type: COMPANY_TYPE };
  type: USER_TYPE;
  isAwaitingApproval: boolean;
}) => user?.company.type === COMPANY_TYPE.agent && !user.isAwaitingApproval;

export const getUserDepartmentOrJobTitle = (props: {
  t: TypeSafeTFunction;
  user: {
    departmentType: DEPARTMENT_TYPE | null;
    customDepartmentName: string | null;
    jobTitle: string | null;
  };
  isPrincipalUser: boolean;
}): string => {
  const { t, user, isPrincipalUser } = props;

  if (isPrincipalUser) {
    const translatedDepartmentType =
      user.departmentType && translateDepartmentType(t, user.departmentType);

    if (user.departmentType === DEPARTMENT_TYPE.other) {
      return user.customDepartmentName || translatedDepartmentType || nullString;
    }

    return translatedDepartmentType || nullString;
  }

  return user.jobTitle || nullString;
};
